import React from 'react'
import PropTypes from 'prop-types'

import * as CONST from './../../Reducers/Ambassador/const'
import StyledStatusLabel from './style'
import { CAMPAIGN_INTERNAL_STATUSES } from '../../shared/constants'

const getStatusProp = (statusText = '') => {
  statusText = statusText || ''
  switch (statusText.toLowerCase()) {
    case 'available':
      return { active: true }
    case 'published':
    case 'paid':
    case 'completed':
    case CONST.AMBASSADOR_STATUS_KEY.ACTIVE:
      return { success: true }

    case 'booked':
    case CONST.AMBASSADOR_STATUS_KEY.WAITING_FOR_REVIEW:
      return { waitingForReview: true }
    case 'checked-in':
    case 'checked_in':
      return { checkedIn: true }
    case 'reviewed':
    case 'canceled':
      return { warning: true }
    case 'under review':
      return { underReview: true }
    case 'under_review':
      return { underReview: true }
    case 'cancelled_paid':
      return { cancelledPaid: true }

    case 'draft':
      return { draft: true }
    case 'ready_to_publish':
      return { readyToPublish: true }
    case CONST.AMBASSADOR_STATUS_KEY.PENDING:
      return { pending: true }
    case CONST.AMBASSADOR_STATUS_KEY.BOOKED_MEETING:
      return { bookedMeeting: true }
    case CONST.AMBASSADOR_STATUS_KEY.PRE_ACCESS:
      return { preAccess: true }

    case 'onsite_training':
    case 'onsite training':
    case 'on_site_training':
      return { onsiteTraining: true }
    case 'no_shown':
      return { noShown: true }
    case 'archived':
      return { underReview: true }
    case 'active':
      return { active: true }
    default:
      return { default: true }
  }
}

const StatusLabel = ({ status, isSpied = false }) => (
  <StyledStatusLabel isSpied={isSpied} {...getStatusProp(status)}>
    {getReadableStatus(status)}
  </StyledStatusLabel>
)

StatusLabel.propType = {
  status: PropTypes.string.isRequired,
}

export { StatusLabel }

export const getReadableInternalStatusV1 = internalStatus => {
  if ([CAMPAIGN_INTERNAL_STATUSES.IN_REVIEW].includes(internalStatus)) {
    return 'In Review'
  } else if (
    [
      CAMPAIGN_INTERNAL_STATUSES.CODE_REVIEW,
      CAMPAIGN_INTERNAL_STATUSES.UPLOAD_CODES,
      CAMPAIGN_INTERNAL_STATUSES.UPLOAD_CODES_DECLINED,
      CAMPAIGN_INTERNAL_STATUSES.GENERATING_DIGITAL_PROOF,
      CAMPAIGN_INTERNAL_STATUSES.PENDING_DIGITAL_PROOF,
      CAMPAIGN_INTERNAL_STATUSES.PAYMENT,
    ].includes(internalStatus)
  ) {
    return 'Approved'
  } else if (internalStatus === CAMPAIGN_INTERNAL_STATUSES.REJECTED) {
    return 'Action required'
  } else if (internalStatus === CAMPAIGN_INTERNAL_STATUSES.DRAFT) {
    return 'Draft'
  } else if (internalStatus === CAMPAIGN_INTERNAL_STATUSES.ACTIVE) {
    return 'Active'
  } else if (internalStatus === CAMPAIGN_INTERNAL_STATUSES.COMPLETED) {
    return 'Completed'
  }
  return null
}

const getReadableStatus = status => {
  if (Object.values(CONST.AMBASSADOR_STATUS_KEY).includes(status))
    return CONST.AMBASSADOR_STATUS_LABEL[status]

  switch (status) {
    case 'ACTIVE':
      return 'active'
    case 'DRAFT':
      return 'draft'
    case 'READY_TO_PUBLISH':
      return 'ready to publish'
    case 'AVAILABLE':
      return 'available'
    case 'BOOKED':
      return 'booked'
    case 'TERMINATING':
      return 'terminating'
    case 'PRE_ACCESS':
      return 'pre_access'
    case 'CANCELLED':
      return 'cancelled'
    case 'CHECKED_IN':
      return 'checked-in'
    case 'UNDER_REVIEW':
      return 'under-review'
    case 'COMPLETED':
      return 'completed'
    case 'PAID':
      return 'paid'
    case 'WAITING_FOR_REVIEW':
      return 'Waiting for review'
    case 'CANCELLED_PAID':
      return 'cancelled/paid'
    case 'UNINTERESTED':
      return 'uninterested'
    case 'ON_SITE_TRAINING':
      return 'onsite training'
    case 'NO_SHOWN':
      return 'No Show'
    default:
      return status
  }
}
